<div class="basic-info-container">
    <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" style="display: flex; flex-direction: column"
        *ngIf="!isLoading">
        <!-- <div class="title">
            <h4 style="margin-top: 0" ngStyle.lt-sm="font-size: 18px">Project Address</h4>
        </div> -->
        <div class="flex justify-between align-center border-bottom" style="padding: 32px;">
            <div class="fc_DEDEDE fz_21">Project Address</div>
            <img src="./assets/images/black/close.png" class="close_image" (click)="close()">
        </div>
        <div class="pd_container mt_30 border-bottom">
            <app-auto-complete (setAddress)="getAddress($event)" addressType="geocode" [style]="style">
            </app-auto-complete>
            <div style="display: flex; justify-content: space-between; margin-top: 40px">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Address Line</mat-label>
                    <input matInput type="text" formControlName="addressLine1" />
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Suburb</mat-label>
                    <input matInput type="text" formControlName="area" />
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between;">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>City</mat-label>
                    <input matInput type="text" formControlName="city" />
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Postcode</mat-label>
                    <input matInput type="text" formControlName="postCode" />
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>State</mat-label>
                    <input matInput type="text" formControlName="state" />
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Country</mat-label>
                    <input matInput type="text" formControlName="country" />
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Latitude</mat-label>
                    <input matInput type="text" formControlName="lat" />
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>longitude</mat-label>
                    <input matInput type="text" formControlName="lng" />
                </mat-form-field>
            </div>
            <div class="title">
                <h4 ngStyle.lt-sm="font-size: 18px">Basic Info</h4>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Project Name</mat-label>
                    <input matInput formControlName="pname" required>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Project Type</mat-label>
                    <mat-select formControlName="ptype" required>
                        <mat-option [value]=5>Package (House)</mat-option>
                        <mat-option [value]=6>Package (Townhouse)</mat-option>
                        <mat-option [value]=7>Package (Apartment)</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Project Status</mat-label>
                    <mat-select formControlName="pstatus" required>
                        <mat-option *ngFor="let status of projectStatus" [value]="status.value">
                            {{status.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div style="display: flex; justify-content: space-between; width: 45%">
                    <mat-form-field appearance="outline" style="width: 45%">
                        <mat-label>Commission</mat-label>
                        <input matInput formControlName="commission">
                        <mat-error *ngIf="reactiveForm.invalid">Value has to be a number.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="width: 45%">
                        <mat-label>Commission Unit</mat-label>
                        <mat-select formControlName="commissionUnit">
                            <mat-option value="%">%</mat-option>
                            <mat-option value="AUD">AUD</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>{{this.reactiveForm.get('ptype').value == '4' ? 'Total land lots' : 'Total unit'}}
                    </mat-label>
                    <input matInput formControlName="totalUnit" type="number"
                        onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0">
                </mat-form-field>
                <mat-form-field *ngIf="reactiveForm.get('ptype').value == '4'" appearance="outline" style="width: 45%;">
                    <mat-label>City Council</mat-label>
                    <input matInput formControlName="cityCouncil">
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Website (optional)</mat-label>
                    <input matInput formControlName="website">
                    <!--      <mat-error *ngIf="reactiveForm.get('email').invalid">Invalid email.</mat-error>-->
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>3D Showroom Link</mat-label>
                    <input matInput formControlName="vrUrl">
                    <!--      <mat-error *ngIf="reactiveForm.get('email').invalid">Invalid email.</mat-error>-->
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%;">
                    <mat-label>Introduction (English)</mat-label>
                    <textarea matInput formControlName="introductionEN" style="height: 100px"></textarea>
                    <mat-error *ngIf="reactiveForm.get('introductionEN').invalid">Cannot exceed 2000 characters
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%;">
                    <mat-label>Introduction (Simplified Chinese)</mat-label>
                    <textarea matInput formControlName="introductionZH" style="height: 100px"></textarea>
                    <mat-error *ngIf="reactiveForm.get('introductionZH').invalid">Cannot exceed 2000 characters
                    </mat-error>
                </mat-form-field>
            </div>
            <mat-radio-group formControlName="firb" style="margin-bottom: 20px" required>
                <h4 [ngClass]="{'firb-required': reactiveForm.get('firb').invalid && isSubmitted}"
                    style="margin-top: 0">
                    Include FIRB *</h4>
                <mat-radio-button [value]=1 style="margin-right: 40px">
                    Yes
                </mat-radio-button>
                <mat-radio-button [value]=0>
                    No
                </mat-radio-button>
            </mat-radio-group>

            <h4>Key dates</h4>
            <div fxLayout="row" fxLayoutGap="40px">
                <mat-form-field color="accent" appearance="fill">
                    <mat-label>Start Date (optional)</mat-label>
                    <input matInput [matDatepicker]="picker1" (dateChange)="getStartDate($event)"
                        formControlName="startDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 [startAt]="reactiveForm.get('startDate').value" [disabled]="false">
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field color="accent" appearance="fill">
                    <mat-label>End Date (optional)</mat-label>
                    <input matInput [matDatepicker]="picker2" (dateChange)="getEndDate($event)"
                        formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2 [startAt]="reactiveForm.get('endDate').value" [disabled]="false">
                    </mat-datepicker>
                </mat-form-field>
                <mat-form-field color="accent" appearance="fill">
                    <mat-label>Sunset Date (optional)</mat-label>
                    <input matInput [matDatepicker]="picker3" (dateChange)="getSunsetDate($event)"
                        formControlName="sunsetDate">
                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3 [startAt]="reactiveForm.get('sunsetDate').value" [disabled]="false">
                    </mat-datepicker>
                </mat-form-field>
            </div>
            <h4>Incentives</h4>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Incentive 1 (optional)</mat-label>
                    <input matInput formControlName="incentive1">
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Incentive 2 (optional)</mat-label>
                    <input matInput formControlName="incentive2">
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Incentive 3 (optional)</mat-label>
                    <input matInput formControlName="incentive3">
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Incentive 4 (optional)</mat-label>
                    <input matInput formControlName="incentive4">
                </mat-form-field>
            </div>
            <mat-form-field appearance="outline" style="width: 45%">
                <mat-label>Incentive 5 (optional)</mat-label>
                <input matInput formControlName="incentive5">
            </mat-form-field>
            <ng-container *ngIf="reactiveForm.get('ptype').value != '4'">
                <h4 style="margin-bottom: 5px">Indoor features</h4>
                <div fxLayout="row wrap">
                    <mat-checkbox *ngFor="let feature of indoorFeatures" [checked]="isCheckBoxSelected(feature.id)"
                        (change)="select($event, feature.id)">
                        {{feature.notes.en}}
                    </mat-checkbox>
                </div>
                <h4 style="margin-bottom: 5px">Outdoor features</h4>
                <div fxLayout="row wrap">
                    <mat-checkbox *ngFor="let feature of outdoorFeatures" [checked]="isCheckBoxSelected(feature.id)"
                        (change)="select($event, feature.id)">
                        {{feature.notes.en}}
                    </mat-checkbox>
                </div>
                <h4 style="margin-bottom: 5px">Energy features</h4>
                <div fxLayout="row wrap">
                    <mat-checkbox *ngFor="let feature of energyFeatures" [checked]="isCheckBoxSelected(feature.id)"
                        (change)="select($event, feature.id)">
                        {{feature.notes.en}}
                    </mat-checkbox>
                </div>
            </ng-container>


        </div>
        <div class="pd_container" style="padding: 32px;">
            <button mat-button class="add_button " [ngClass]="{'deactivated': isUpdating, 'activated': !isUpdating}">
                {{isUpdating ? 'Updating...' : 'Update'}}
            </button>
        </div>

    </form>
    <app-loading *ngIf="isLoading"></app-loading>
</div>